import { INTEGER, UUID } from '@belimo-retrofit-portal/logic';
import { Json } from 'fp-ts/Json';
import * as C from 'io-ts/Codec';
import { Asset } from 'src/modules/common/types/Asset';

export const ASSET: C.Codec<unknown, Json, Asset> = C.struct({
  id: UUID,
  fileName: C.string,
  fileSize: INTEGER,
  mimeType: C.string,
});
